import * as d3 from 'd3';
import { dN_Rect } from './d_rect';
import { drawHinge } from './drawHinge';
import { drawGrills } from './drawGrills';
import { drawTopTilt } from './drawTopTilt';
import { getGlassDesign } from './glassPatternsDefs';

export function drawAwning(nSections = 5, indexWindow = 1,
    svg, d = 2, initX = 20, initY = 20, frameWidth = 10, doorData = null, top = false, OneSection = false)
{
    const frameData = doorData?.frameData;
    const finish = doorData?.finish;
    const finishColor = doorData.flipped ? doorData?.finish?.exteriorColor?.value || 'white' :
                                           doorData?.finish?.interiorColor?.value || 'white' ;

    // Access type dynamically
    let type = 'type';
    let windowHeight = parseFloat(frameData.windowHeight_d); 
    if (top){
        type = 'typeTop';
        windowHeight = parseFloat(frameData?.uHeight_d || 0); 
    }
    const typeKey = `${type}${indexWindow}`;
    const widthKey = `windowWidth${indexWindow}_d`;

    if (frameData?.[typeKey] === 'Awning') {
        let windowWidth = parseFloat(frameData[widthKey]);
        //const windowHeight = parseFloat(frameData.windowHeight_d); // - 2*d;

        let adjustedWidth = (windowWidth - frameWidth * 2) / 2;

        let xOffset = initX ;
        for (let i = 1; i < indexWindow; i++) {
            const key = `windowWidth${i}_d`;
            //const key = `windowWidth${i}_d`;
            //const width = parseFloat(frameData?.[key]) || 50;
            xOffset += parseFloat(frameData[key] || 0) + 2 * frameWidth + 2*d ;
        }
        
      
        const glassType = `glassType${indexWindow}`;
        const glassColor = doorData?.glass?.[glassType].value || 'white';
        if (OneSection){
            xOffset = initX;
            windowWidth = parseFloat(frameData?.uWidth1_d)  - 
            2 * frameWidth - 2*d + parseInt(nSections);
            adjustedWidth = (windowWidth - 2 * frameWidth)*0.5;
        }
        const glassDesign = getGlassDesign(doorData);
        dN_Rect(svg, d, xOffset , initY, [
            {
                w: windowWidth, //2*adjustedWidth + 2*frameWidth - 1,
                h: windowHeight - 1,
                color: glassColor, //'lightblue',
                glassType: doorData?.glass?.glassType1.label,
                glassDesign: glassDesign,
                frameWidth,
                frameColor: finishColor,
                lineFrameColor: 'black',
                lineFrameThickness: 1,
                outerStrokeColor: 'black',
                outerStrokeWidth: 1,
                fullCorners: true
            }
        ], {
            labelText: `\u00A0${indexWindow} ✔`,
            subFrame: true,
            labelOptions: {
                fontSize: 24,
                fontColor: 'green',
                fontOpacity: 0.2
            },
            drawFrame: true
        });
        

        drawGrills(svg, indexWindow,
                    xOffset , initY, 
                    windowWidth, /*2*adjustedWidth + 2*frameWidth,*/ 
                    windowHeight, 
                    frameWidth,
                    doorData, top);

        
          /*drawHinge(
                      svg,
                      xOffset + d, initY, 2*adjustedWidth + 2*frameWidth, windowHeight, frameWidth,                      
                      2,  // hingeType: 1 = left, 2 = right
                      'red'
                    );*/ 
            drawTopTilt(svg, xOffset , initY - 0.0, windowWidth, windowHeight , frameWidth, 'red', 'up'); 

    }// if awning
}//drawAwning
